import React, {Component} from 'react'

class IconArrow extends Component{
    render(){
        const styles = {
            fill: this.props.color,
            width: this.props.width,
            height: this.props.height
        }
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" 
            viewBox="0 0 32.6 32.6"
            style={styles}
            >	
            <style>
                {`   `}
            </style>
            <path d="M16.3,32.5c-0.3,0-0.8-0.4-0.8-0.6V0.4l1.7,0c0,0,0,0,0,0l0,31.5C17.2,32.1,16.6,32.5,16.3,32.5z"/>
            <path d="M15.6,32.1L3.4,19.8l0.9-0.9l12,12.1l12-12l0.9,0.8L16.9,32.2C16.8,32.3,15.6,32.1,15.6,32.1z"/>
            </svg>
        )
    }
} 

export default IconArrow